import React from 'react';
import { Icon, Menu, Select } from 'antd';
import { css } from 'emotion';
import { AuthenticationStore } from '../../../store/AuthenticationStore';
// import { CustomerStore } from 'store/CustomerStore';
import { inject, observer } from 'mobx-react';
import { LocaleStore } from '../../../store/LocaleStore';
import { Link } from 'react-router-dom';
import { Page } from '../../../common/enums';
import { Instance } from 'mobx-state-tree';
import { pulsarLogo } from '../../../assets';
import styled from '@emotion/styled';
import { SecretariatStore } from '../../../store';

const Container = styled.div`
  color: black;
`;

const SpecialContainer = styled.div`
  color: red;
`;

const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;

interface RightContentProps {
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  // ApplicationStore?: Instance<typeof ApplicationStore.Type>;
  LocaleStore?: Instance<typeof LocaleStore.Type>;
  SecretariatStore?: Instance<typeof SecretariatStore>;
}

// tslint:disable-next-line:no-empty-interface
interface RightContentState {
  // customerList: typeof Customer.Type[];
}

@inject('AuthenticationStore')
@inject('LocaleStore')
@inject('SecretariatStore')
@observer
class RightContent extends React.Component<RightContentProps, RightContentState> {
  constructor(props: {}) {
    super(props);
    this.state = {
      customerList: [],
    };
  }

  async componentDidMount() {
    await this.props.SecretariatStore!.checkListLoaded(); // loadList();
    this.props.SecretariatStore!.setSelectedSecretariat(
      this.props.SecretariatStore!.dataList.sort((s) => s.secretariatId)[0],
    );
  }

  render() {
    const localeStore = this.props.LocaleStore!;
    const secretariatStore = this.props.SecretariatStore!;
    return (
      <div
        className={css({
          float: 'right',
          height: '100%',
          width: '550px',
          overflow: 'hidden',
        })}
      >
        <Menu
          mode="horizontal"
          theme="light"
          selectable={false}
          style={{ lineHeight: '64px', backgroundColor: '#7FB9BD' }}
        >
          <Menu.Item>
            <Select
              defaultValue={localeStore.currentLocale}
              style={{ width: 120 }}
              onChange={(e) => localeStore.setCurrentLocale(e)}
            >
              {localeStore.allLocales.map((locale) => (
                <Select.Option key={locale} value={locale}>
                  {locale.toUpperCase()}
                </Select.Option>
              ))}
            </Select>
          </Menu.Item>
          {this.props.AuthenticationStore!.isSuperAdmin && secretariatStore.dataList.length > 0 && (
            <Menu.Item>
              <Select
                defaultValue={secretariatStore.dataList.sort((s) => s.secretariatId)[0].code}
                style={{ width: 130 }}
                onChange={(code) =>
                  secretariatStore.setSelectedSecretariat(
                    code === 'All' ? undefined : secretariatStore!.dataList.find((s) => s.code === code)!,
                  )
                }
              >
                {secretariatStore.dataList
                  .map((sec) => (
                    <Select.Option key={sec.code} value={sec.code}>
                      {sec.code}
                    </Select.Option>
                  ))
                  .concat(
                    <Select.Option key={'All'} value={'All'}>
                      {'All'}
                    </Select.Option>,
                  )}
              </Select>
            </Menu.Item>
          )}
          <SubMenu
            title={
              this.props.AuthenticationStore!.isImpersonated ? (
                <SpecialContainer>
                  <span>
                    <Icon type="user" />
                    {this.props.AuthenticationStore!.userName}
                  </span>
                </SpecialContainer>
              ) : (
                <span>
                  <Icon type="user" />
                  {this.props.AuthenticationStore!.userName}
                </span>
              )
            }
          >
            <Menu.Item key="setting:1">
              <Icon type="exclamation-circle-o" />
              <span>Logout</span>
              <Link to={Page.Login} />
            </Menu.Item>
          </SubMenu>
          <Menu.Item>
            <a href="http://www.pulsar.be" target="_blank">
              <img
                src={pulsarLogo}
                height={31}
                className={css({
                  verticalAlign: 'center',
                  textAlign: 'center',
                  // marginTop: '16px',
                })}
              />
            </a>
          </Menu.Item>
        </Menu>
      </div>
    );
  }
}

export default RightContent;
